module.exports = __webpack_public_path__ + "static/media/Screenshot-2020-08-26-at-10.35.27.292350dc.png";